import { render } from "./NavBar.vue?vue&type=template&id=5bda343c&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=5bda343c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5bda343c"

export default script